
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eigentuemer",
      function () {
        return require("private-next-pages/eigentuemer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eigentuemer"])
      });
    }
  